module.exports = __webpack_public_path__ + "static/bg-sidebar-everyday-life-8d2197e034e42122341831d98284b5f3.svg";